import { useEffect, useState } from 'react';
import { listWikiProjects, WikiProject } from '../api/wiki';

export function ProjectsList() {
  const [projects, setProjects] = useState<WikiProject[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void listWikiProjects()
      .then((r) => {
        if (!cancelled) setProjects(r.projects);
      })
      .catch((e) => {
        if (!cancelled) setError((e as Error).message);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (error)
    return (
      <div style={{ padding: 24 }}>
        <h2>LIBRARIAN-Wiki</h2>
        <div className="banner banner-warning">
          {error.includes('WIKI_DISABLED')
            ? 'The wiki module is currently disabled. Enable it in Settings → Wiki.'
            : `Error loading projects: ${error}`}
        </div>
      </div>
    );
  if (!projects) return <div style={{ padding: 24 }}>Loading…</div>;
  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>LIBRARIAN-Wiki</h2>
      <div
        style={{
          display: 'grid',
          gap: 12,
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        }}
      >
        {projects.map((p) => (
          <a
            key={p.id}
            href={`#/wiki/p/${encodeURIComponent(p.id)}`}
            style={{
              display: 'block',
              padding: 16,
              border: '1px solid var(--border, #444)',
              borderRadius: 8,
              textDecoration: 'none',
              color: 'inherit',
              background: p.archived ? 'rgba(80,80,80,0.2)' : 'transparent',
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: 6 }}>
              📚 {p.name} {p.archived ? '(archived)' : null}
            </div>
            {p.description ? (
              <div className="muted small" style={{ marginBottom: 6 }}>
                {p.description}
              </div>
            ) : null}
            <div className="muted small">
              {p.page_count} pages · {p.source_count} sources
            </div>
            {p.last_ingest_ts ? (
              <div className="muted small">
                Last ingest:{' '}
                {new Date(p.last_ingest_ts).toLocaleString()}
              </div>
            ) : null}
          </a>
        ))}
      </div>
    </div>
  );
}
